import { NgModule, ModuleWithProviders, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpConfiguration } from '../app.http.config';
import { Configuration } from '../app.config';
import { CookieService } from 'angular2-cookie';
import AccountHttpService from './http/internal/account.http.service';
import ClientHttpService from './http/kartinatv/client.http.service';
import { DeviceService } from '../services/device-service';
import { KartinaTvHttpService } from './http/kartinatv/base.http.service';
import { KartinaErrorsService } from '../services/kartina-errors-service';

// ReSharper disable once InconsistentNaming
declare let Raven: any;
export class RavenErrorHandler implements ErrorHandler {
    handleError(err: any): void {
        Raven.captureException(err);
        console.log(err);
    }
}

@NgModule({
    imports: [
        CommonModule
    ]
})

export class HttpCoreModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: HttpCoreModule,
            providers: [
                Configuration,
                HttpConfiguration,
                CookieService,
                AccountHttpService,
                ClientHttpService,
                DeviceService,
                KartinaTvHttpService,
                KartinaErrorsService
            ]
        };
    }
}


// WEBPACK FOOTER //
// ./src/app/core/http.core.module.ts